import React from "react";

import defaultIconProps from "@/constants/defaultIconProps";
import IconProps from "@/types/icons/IconProps";

const CloseSmallIcon: React.FC<IconProps> = (props) => {
  const { width, height, fontSize, color } = {
    ...defaultIconProps, ...props
  };
  return (
    <svg xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      height={height}
      width={width}
      style={{ fontSize }}
      {...props}>
      <path d="M12 13.4L9.1 16.3C8.91667 16.4833 8.68334 16.575 8.4 16.575C8.11667 16.575 7.88334 16.4833 7.7 16.3C7.51667 16.1167 7.425 15.8833 7.425 15.6C7.425 15.3167 7.51667 15.0833 7.7 14.9L10.6 12L7.7 9.125C7.51667 8.94167 7.425 8.70833 7.425 8.425C7.425 8.14167 7.51667 7.90833 7.7 7.725C7.88334 7.54167 8.11667 7.45 8.4 7.45C8.68334 7.45 8.91667 7.54167 9.1 7.725L12 10.625L14.875 7.725C15.0583 7.54167 15.2917 7.45 15.575 7.45C15.8583 7.45 16.0917 7.54167 16.275 7.725C16.475 7.925 16.575 8.1625 16.575 8.4375C16.575 8.7125 16.475 8.94167 16.275 9.125L13.375 12L16.275 14.9C16.4583 15.0833 16.55 15.3167 16.55 15.6C16.55 15.8833 16.4583 16.1167 16.275 16.3C16.075 16.5 15.8375 16.6 15.5625 16.6C15.2875 16.6 15.0583 16.5 14.875 16.3L12 13.4Z" fill={color} />
    </svg>

  );
};

export default CloseSmallIcon;
